import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <h4 className="font-heading text-xl font-bold text-background-50 mb-3">色即是空</h4>
            <p className="text-sm leading-relaxed text-background-200">
              专注影视解析与演员资讯的内容服务平台，助力观众更好地理解与欣赏每一部作品。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="flex flex-col gap-2 text-sm text-background-200">
              <li><Link to="/category/movie" className="hover:text-accent-400 cursor-pointer">电影列表</Link></li>
              <li><Link to="/category/tv" className="hover:text-accent-400 cursor-pointer">电视剧列表</Link></li>
              <li><Link to="/actors" className="hover:text-accent-400 cursor-pointer">演员资讯</Link></li>
              <li><Link to="/search" className="hover:text-accent-400 cursor-pointer">搜索</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关于平台</h4>
            <ul className="flex flex-col gap-2 text-sm text-background-200">
              <li><Link to="/about" className="hover:text-accent-400 cursor-pointer">关于我们</Link></li>
              <li><span className="cursor-default">使用说明</span></li>
              <li><span className="cursor-default">隐私声明</span></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系方式</h4>
            <ul className="flex flex-col gap-2 text-sm text-background-200">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>contact@sejishikong.com</span>
              </li>
              <li className="flex items-center gap-3 mt-1">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-800 hover:bg-accent-500 cursor-pointer transition-colors">
                  <i className="ri-weibo-line"></i>
                </div>
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-800 hover:bg-accent-500 cursor-pointer transition-colors">
                  <i className="ri-wechat-line"></i>
                </div>
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-800 hover:bg-accent-500 cursor-pointer transition-colors">
                  <i className="ri-douban-line"></i>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-300">
          <p>© 2026 色即是空. 内容均为前端演示数据，不含真实播放/下载/支付功能。</p>
          <p>本站所有解析内容版权归原作者所有</p>
        </div>
      </div>
    </footer>
  );
}